<template>
  <div class="container">
    <router-link to="/">◀︎TOPへ戻る</router-link>
    <div class="title">
      <img src="../assets/otofuda_title.png">
      <h2>音札</h2>
    </div>
    <h3>概要・コンセプト</h3>
    <div class="content">
      <p>
        「音札(おとふだ)」は花札をモチーフとしたカードゲーム要素と音楽ゲームを融合させた新感覚の対戦型音楽カードゲームです。
        手の動きを認識するLeapMotionというデバイスを用いた、空間を操るような操作が特徴です。<br>
        これまで音楽ゲームの対戦といえば、プレイが上手い人がたくさんのスコアを獲得し勝利するという単純なものですが、音札ではカードゲームによる戦略要素が加わることによって、
        音楽ゲームの腕前だけに依存しない新しい対戦スタイルを生み出しています。<br>
        <br>
        音札ではゲーム本体の開発の他に様々な展開を行っています。<br>
        <ul>
          <li>プレイヤー向け連動サイト開発</li>
          <li>ホームページ上でのストーリー展開</li>
          <li>4コマ漫画「おとふだびより♪」</li>
          <li>オリジナルグッズ販売</li>
          <li>YouTube/niconicoでの動画公開</li>
        </ul>
        2020年11月29日に、秋葉原UDXで開催されたデジゲー博2020に出展しました。<br>
        <br>
        私は2020年度から制作チームに参加しています。
      </p>
    </div>
    
    <h3>担当した箇所</h3>
    <div class="content">
      <div class="ribon"><h4>キャラクターデザイン/イラストレーション</h4></div>
      <p>
        音札には4人の個性的なキャラクターがいます。2019年度時点では華音(かのん)と門音(かどね)2人を展開していましたが、2020年度から空音(くのん)と大音(ひろの)が加わり4人での展開を行ってきました。<br>
        華音の新衣装の原案・空音のキャラクターデザインと衣装の原案、大音のキャラクターデザインと衣装デザインを担当させていただきました。<br>
        また、音札オリジナル曲やその他一部の楽曲のジャケットイラストも担当しています。
      </p>
  
      <div class="ribon"><h4>譜面制作</h4></div>
      <p>
        譜面チームの一員として、様々な楽曲の譜面を担当しました。<br>
        音札では譜面の難易度は1曲に大して3つあり、簡単な順に緑→橙→赤となっています。<br>
        レベルは10段回表記で、数字が大きいほど難しい譜面です。
        <ul>
          <li>Chartreuse Green/t+pazolite <span class="e">2</span> <span class="n">6</span> <span class="h">9</span></li>
          <li>Rubbish Sorting/Ctymax vs. NcsS <span class="e">1</span> <span class="n">4</span> <span class="h">8</span></li>
          <li>もぺもぺ/LeaF <span class="e">2</span> <span class="n">4</span> <span class="h">9</span></li>
          <li>いつも一緒に/nem*(歌:つむぎ&武者丸) <span class="e">2</span> <span class="n">5</span></li>
          <li>Take the rhythm!!/simo <span class="e">2</span> <span class="n">4</span> <span class="h">7</span></li>
          <li>GOODBOUNCE/EBIMAYO <span class="e">3</span> <span class="n">7</span> <span class="h">9</span></li>
        </ul>
        譜面動画は<a href="https://youtube.com/playlist?list=PLul2egJa-wXI43ikavfEoPUqVpTeTQW4s" target="_blank" rel="noopener noreferrer">こちら</a>から
        (YouTubeの再生リストへ飛びます)<br>
        <br>
        その他いくつかの合作譜面の制作に参加しています。
      </p>
  
      <div class="ribon"><h4>4コマ漫画「おとふだびより♪」</h4></div>
      <p>
        公式Twitter上で、音札の世界をゆるっと描く4コマ漫画シリーズ「おとふだびより♪」を連載しています。<br>
        2021年3月現在、キャラクター紹介編(全4話)・天ノ葉神社日本支部コラボ編(全3話)を含めて合計26話分が公開されており、ホームページの「ストーリー」タブからアーカイブを閲覧することができます。<br>
        おとふだびより♪ではお話のゆるさに合わせてイラストもゆるいデザインを採用し、ギャグ要素も含めながら4人のキャラクターの日常を描いています。
      </p>

      <div class="ribon"><h4>プレイヤー用サイト「おとふだNET」</h4></div>
      <p>
        「おとふだNET」は音札プレイヤー向けのサービスです。<br>
        主な機能はプレイリザルトの閲覧・プレイ設定の変更・プロフィール機能・デッキ編成となっています。<br>
        音札ではプレイヤーは12の月から5つの月を選んで自分のデッキとし、デッキに構成されている札を用いて相手プレイヤーと戦います。<br>
        <br>
        デッキ新規作成・編集・削除・メインデッキ選択の機能と、そのUIの開発を担当しました。<br>
        作成したデッキの詳細画面では、そのデッキに含まれている札の一覧を確認することができます。
      </p>
      
    <div class="ribon"><h4>その他</h4></div>
      <p>
        上記の他、譜面制作ツールの開発補助やグッズデザイン・企画などにも参加しております。
        また、天ノ葉神社日本支部コラボではコラボチャプターのシナリオも担当しました。
      </p>
    </div>
    
    <h3>工夫した点/苦労した点・その他コメント</h3>
    <div class="content">
      <div class="ribon"><h4>譜面制作に関して</h4></div>
      <p>
        譜面は、ある程度自由な解釈で制作しても良いことになっていたためほとんどリテイクはかからず、私個人の解釈で制作しています。<br>
        音札では、「音札ノーツ(黄色い５レーン分の幅のノーツ)のタイミングで手札から1枚ドローしその効果を発動する」というゲームシステムになっているため、
        各音札ノーツの間のどこかのタイミングで手札を選択できるような猶予を作ったり、1曲の中である程度均等な配分で決められた個数の音札ノーツを配置したりする必要があります。<br>
        もちろん楽曲の長さや演出・難易度によってはこの限りではありませんが、「対戦型音楽カードゲーム」という根本的な趣旨から逸れないよう、気をつけて制作しています。<br>
        また、音札オリジナルではない楽曲ではその楽曲が元々収録されていた音楽ゲームでの譜面を再現したり、BGA(バックグラウンドアニメーション)の演出を譜面で表現したりするなどの工夫もしています。<br>
        <br>
        特に2021年3月現在最新作のEBIMAYO氏の「GOODBOUNCE」では、BGA再現でアルファベットを表現したり、駆け上る階段をノーツの配置で表現したり、
        ロングノーツで片手を拘束したままもう片方の手を左右にバウンドさせる運指になるような配置を取り入れたりした渾身の譜面です。
        <br>
        <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/Pq2tAikqaxQ?controls=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </p>
      <div class="ribon"><h4>おとふだびより♪・イラストレーションに関して</h4></div>
      <p>
        イラスト作品に関しては、とにかく音札に興味を持ってくれる人が増えるように・可愛く描くようにを心がけて制作しました。<br>
        キャラクターデザインは、シナリオライターがキャラクターのイメージの原案をし、それを私がイラストにおこすというフローでおこないました。
        キャラクターの内面的な設定は主にシナリオライターが、キャラクターの外面的な設定は主に私が担当しているという感じです。<br>
        私がチームに参加してから新しく登場した空音(くのん)と大音(ひろの)の衣装は、空音は「中性的な外見だけど内面は普通の女の子」という設定から落ち着いた大正浪漫風の長い丈のスカートとブーツを考え、
        元気一杯で強がりな大音にはちょっと現代風なプリーツスカートと低身長を誤魔化すための厚底下駄をデザインしました。<br>
        また、4人が同じ所属であることを表すため、挿し色は揃えて赤を使っています。<br>
        <br>
        おとふだびより♪は脚本と作画の両方を担当しています。<br>
        本編ストーリーの更新が頻繁ではない分、4人のキャラクター性をおとふだびより♪で積極的に描こうという方針で制作が始まり、2021年3月現在も連載が続いています。<br>
        制作フローはネーム→シナリオライターによる校閲→清書→ロゴやクレジット表記を追加して掲載という4段回で行っています。<br>
        音札の世界の日常を描写しつつ4コマで起承転結をつけるのはとても難しく、今見返すと落ちが弱い回も多いのが反省点です。<br>
        <br>
        また、キャラクターのイラストのタッチはおとふだびより♪専用に新しく考えたもので、最低限の表情を表現できるギリギリのラインのデフォルメとして気に入っています。
      </p>
    </div>
        
    <h3>関連リンク</h3>
    <div class="content">
      <p>
        音札に関する各種リンクはこちらです。<br>
        おとふだNETは筐体で登録したカードの情報が必要になるため、現在新規での登録はできない状況となっております。
        <ul>
          <li><a href="https://www.ne.senshu-u.ac.jp/~proj2019-13/" target="_blank" rel="noopener noreferrer">公式ホームページ</a></li>
          <li><a href="https://www.youtube.com/channel/UC9G3cMsWdkGC6QJz1EbczBg" target="_blank" rel="noopener noreferrer">YouTubeチャンネル</a></li>
          <li><a href="https://twitter.com/otofuda" target="_blank" rel="noopener noreferrer">Twitter</a></li>
          <li>
            <a href="https://otofudanet.herokuapp.com/" target="_blank" rel="noopener noreferrer">おとふだNET</a>
            <a href="https://github.com/mtsgi/otofudanet" target="_blank" rel="noopener noreferrer"><img src="../assets/GitHub-Mark-64px.png" class="git"></a>
          </li>
        </ul>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Otofuda',
  head: {
    title: {
      inner: '音札',
      complement: 'Megane Case'
    },
    meta: [
      { name: 'robots', content: 'noindex'}
    ]
  }
}
</script>

<style lang="scss" scoped>
@import "../stylesheets/body";
.e,.n,.h{
  display: inline-block;
  padding: 0 5px;
  margin: 1px;
  border-radius: 5px;
  color: white;
}
.e{
  background-color: #00d500;
}
.n{
  background-color: #ffb300;
}
.h{
  background-color: #ff007f;
}

</style>
